import { useMemo } from 'react';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { NotificationsApiAdapter } from '../adapters/NotificationsApiAdapter';
import { useAuthStore } from '@shared/stores/authStore';
import type { NotificationPreferencesQueryParams } from '../models/Notification.types';

export interface UseNotificationPreferencesOptions {
  /** Parámetros de query: per_page, page, sorting, advanced_filters */
  queryParams?: NotificationPreferencesQueryParams;
}

export const useNotificationPreferences = (options: UseNotificationPreferencesOptions = {}) => {
  const { queryParams } = options;
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new NotificationsApiAdapter(httpClient);
  const user = useAuthStore((state) => state.user);
  const userId = user?.id;

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['notification-preferences', userId, queryParams],
    queryFn: () => adapter.getPreferences(queryParams ?? {}),
    staleTime: 5 * 60 * 1000,
    enabled: !!userId,
  });

  // API puede devolver preferencias de varios usuarios del equipo, filtrar por usuario actual
  const preferences = useMemo(() => (data?.data ?? []).filter((pref) => pref.user_id === userId), [data?.data, userId]);

  return {
    preferences,
    meta: data?.meta,
    links: data?.links,
    isLoading,
    error,
    refetch,
  };
};
